import { Footer } from "@nju/feature-portal-footer";
import { ErrorPage } from "@nju/feature-portal-wwt";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function WwtError() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent grid="narrow" spacing="xl">
        <ClientSideOnly>
          <ErrorPage variant="sales" />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
